import { createContext, useContext } from "react";

export const WA_NUMBER = "6282124255020";
export const LangContext = createContext({ lang: "id", setLang: () => {} });
export const useLang = () => useContext(LangContext);

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; };
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const formatIDR = (n) => `Rp ${n.toLocaleString("id-ID")}`;

export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const EASE = [0.22, 1, 0.36, 1];
